export const projectManagementTabsArticle = {
  title: 'Project Management Hub: Projects, Tasks & Portfolios',
  slug: 'project-management-tabs',
  content: `Project Management Hub: Projects, Tasks & Portfolios

Use hub tabs to manage delivery and assignments.

1) Projects
- Use Projects to create and track project workspaces.

2) My Tasks & Tasks
- My Tasks focuses on your assignments.
- Tasks shows team-wide tasks and status.

3) Portfolios
- Use Portfolios to roll up multiple projects and track health.

4) Goals
- Set goals to align work with outcomes.

5) Workload & Team
- Workload shows capacity (team plan).
- Team surfaces collaboration views (team plan).
`,
};
